// src/components/Section1.js
import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  background-color: #000000;
  padding: 5% 6%;
  box-sizing: border-box;

  @media (min-width: 500px) {
    padding: 5% 12% 5% 12%;
  }

`;

const CardContainer = styled.div`
  
  display: flex;
  flex-direction: column; 
  gap: 24px; 

  
  @media (min-width: 500px) {
    flex-direction: row; 
    gap: 80px; 
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #1f1f1f;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  flex: 1;
  max-width: 100%;
  height: auto;
  padding: 36px;


  @media (max-width: 500px) {
    padding: 16px;
  }

`;

const Title = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  color: #FFFFFF;
  margin-top:10px;
  margin-bottom:0px;

  @media (max-width: 500px) {
    font-size: 24px;
    line-height: 35px;
    margin-bottom:4px;
  }

`;

const Subtitle = styled.span`
  color: #FFFFFF;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  display: flex;
  align-items: flex-start;
  margin-top:20px;
  

  @media (max-width: 500px) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom:16px;
    align-items: flex-start;
  }
`;


const Content = styled.p`
  color: #EFEFEF;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  margin-bottom:20px;

  @media (max-width: 500px) {
    font-size: 14px;
    margin-bottom:16px;
    line-height: 24px;
  }
`;

const Content_time = styled.p`
  color: #EFEFEF;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  margin-bottom:0;

  @media (max-width: 500px) {
    font-size: 14px;
    margin-bottom:8px;
    line-height: 12px;
  }
`;

const Content_location = styled.p`
  color: #EFEFEF;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  margin-bottom:12px;

  @media (max-width: 500px) {
    font-size: 14px;
    margin-bottom:16px;
    line-height: 12px;
  }
`;

const Button = styled.button`
  background-color:#1f1f1f;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin-left: auto;

  @media (max-width: 500px) {
    font-size: 14px;
    margin-top:16px;
    line-height: 24px;
    padding: 6px 20px;
    
  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;



const Node = styled.a`
  color: #FFF56A;
  text-decoration: none;
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 12px;
  white-space: nowrap; 
  margin-left: 0;
  margin-right: 10px;
  margin-top: 10px;

  @media (max-width: 500px) {
    font-size: 36px;
    margin-top: 4px;
    margin-right: 5px;

  }
`;

const Section1 = () => (
  <SectionWrapper>
    <CardContainer>
      <Card>
        <Title>次世代數位寶島
        <Subtitle>
          <Node>• </Node>數位社會基礎建設體驗展
        </Subtitle>
        </Title>
        <Content>
          當我們探索 "數位社會基礎建設" 展覽的概念時，我們開始想像新的社會規則與機制，如果這個社會建基在去中心化和區塊鏈技術之上，我們應該擁護哪些價值？創造什麼社會特性？<br/><br/>
          在這個展覽中，我們展示 Taiwan DID 在實驗階段的計畫。你可以將你的行動自然人憑證連接到加密貨幣的錢包，啟用一個可以自行掌控、保護隱私、互通堆疊的身份架構。<br/><br/>
          我們也歡迎你使用 Taiwan DID，或是進入我們的零知識證明投票亭進行趣味投票，因為零知識證明（Zero knowledge proof）技術的保護，在線上證明自身公民身份的同時，也能完全匿名投票或發表意見，便是 Web3 科技所能為社會帶來的改變之一。
          
        </Content>
        <Content_time>展期時間：2023/12/9 - 2023/12/10</Content_time>
        <Content_location>展覽地點：松菸</Content_location>
        

      </Card>
      <Card>
        <Title>DAO Taipei
        <Subtitle>
          <Node>• </Node>台灣第一場 DAO 活動
        </Subtitle>
        </Title>
        <Content>
          分散式自治組織(Decentralized Autonomous Organization，簡稱 DAO)在過去幾年內遍地開花，各個國家、區域或甚至專業領域中，都逐漸有不同形式的 DAO 慢慢生成。這些 DAO 反映的不只是人們對新興合作模式的追求，更是工作型態和社會文化交織而成的創新社會敘事。本次活動旨在邀請東西方各種不同性質的 DAO，希望創造 DAO 和 DAO 之間的友善交流平台，除了分享經驗外，也共同推動新形態的組織形式。
          
        </Content>
        <Content_time>展期時間：2023/12/17 13:00 ~21:00</Content_time>
        <Content_location>展覽地點：恆成紙業</Content_location>
        <a href="https://www.daotaipei.xyz/" target="_blank" style={{ textDecoration: 'none' }}>
        <Button>活動網站</Button>
        </a>
        
        
        
      </Card>
    </CardContainer>
  </SectionWrapper>
);

export default Section1;
